var team26 = [
  [
    {
      name: "Prof. Rajesh Sathiyamoorthy",
      post: "HOD",
      fb: "https://www.facebook.com/profile.php?id=100005799362676",
      insta: "https://www.instagram.com/govind_gupta_46/",
      linkedin:
        "https://www.linkedin.com/in/rajesh-sathiyamoorthy-3695a64b/",
      website: "https://home.iitk.ac.in/~hsrajesh/",
      mail: "mailto:hsrajesh@iitk.ac.in",
      image: "/team/team26/prof.Rajesh.png",
    },
    {
      name: "Prof.Subhadip Das",
      post: "Faculty Advisor",
      fb: " ",
      insta: " ",
      linkedin: "https://www.linkedin.com/in/sdas-uw/",
      website: "https://www.iitk.ac.in/new/subhadip-das",
      mail: "mailto:subhadipd@iitk.ac.in",
      image: "/team/team25/Subhadip_Das_Faculty_Advisor.jpg",
    },
  ],
  [
    {
      id: "1",
      name: "Saksham",
      post: "Events",
      fb: "",
      insta: "#",
      linkedin: "https://www.linkedin.com/feed/",
      mail: "mailto:saksham24@iitk.ac.in",
      image: "/team/team26/Saksham_Event.jpg",
    },
    {
      id: "8",
      name: "Nikita Joshi ",
      post: "Events ",
      fb: " ",
      insta: "https://www.instagram.com/nikkijoshi165/",
      linkedin: "https://www.linkedin.com/in/nikita-joshi-b60415215",
      mail: "mailto:nikitaj23@iitk.ac.in",
      image: "/team/team26/Nikita Joshi.jpg",
    },
    {
      id: "2",
      name: "Nikhil Prajapati",
      post: "Web",
      fb: "",
      insta: "https://www.instagram.com/nikhilprajapati_01_/",
      linkedin: "https://www.linkedin.com/in/nikhil-prajapati-15bbab298/",
      mail: "mailto:nikhilr24@iitk.ac.in",
      image: "/team/team26/Nikhil.jpg",
    },
    {
      id: "3",
      name: "Shubham Bharati",
      post: " Design ",
      fb: " ",
      insta:
        "https://www.instagram.com/shubham__bharati_?igsh=MWU0enRjcGJvdTFxNg==",
      linkedin:
        "https://www.linkedin.com/in/shubham-bharati-03286035b?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      mail: "mailto:shubhamb24@iitk.ac.in",
      image: "/team/team26/Shubham_Design.png",
    },
    {
      id: "9",
      name: "Sruja BG ",
      post: "Design ",
      fb: "",
      insta: "https://www.instagram.com/sruja_bg/",
      linkedin:
        "https://www.linkedin.com/in/sruja-bg-57a49a393?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      mail: "mailto:rohitu24@iitk.ac.in",
      image: "/team/team26/Sruja.jpg",
    },
    {
      id: "5",
      name: "Girish Bhojwani",
      post: "Marketing and Finance",
      fb: "",
      insta: "https://www.instagram.com/girish.iitk/",
      linkedin: "https://www.linkedin.com/in/girish-bhojwani-b1315a323",
      mail: "mailto:girishb24@iitk.ac.in",
      image: "/team/team26/Girish_Media.jpg",
    },
    {
      id: "6",
      name: "Kartikey Agarwal",
      post: "Marketing and Finance",
      fb: "Nope",
      insta: "https://www.instagram.com/agarwal.k._/",
      linkedin: "https://www.linkedin.com/in/kartikey-agarwal-48769b31b",
      mail: "mailto:akartikey24@iitk.ac.in",
      image: "/team/team26/kartikey.png",
    },
    {
      id: "7",
      name: "Pinky",
      post: "Media and Content",
      fb: " ",
      insta: "https://www.instagram.com/pinkyreddy_ch/",
      linkedin: "https://www.linkedin.com/in/pinky-chiluveri/",
      mail: "mailto:chiluverip24@iitk.ac.in",
      image: "/team/team26/pinky.jpg",
    },
  ],
  [
    {
      id: "1",
      name: "Avnish Kumar",
      post: "Web",
      fb: "",
      insta: "https://www.instagram.com/avnish_kumar.verma/",
      linkedin:
        "https://www.linkedin.com/in/avnish-kumar-264309379?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      mail: "mailto:avnishkumar25@iitk.ac.in",
      image: "/team/team26/Avnish Kumar.jpg",
    },
    {
      id: "16",
      name: "Abhishek Yadav",
      post: "Design",
      fb: "",
      insta: "https://www.instagram.com/@ABHISHEK250044/",
      linkedin: "https://www.linkedin.com/in/abhishek-yadav-a1b5953b4",
      mail: "mailto:abhisheky25@iitk.ac.in",
      image: "/team/team26/suman yadav.jpg",
    },
    {
      id: "2",
      name: "Antima Dhakar",
      post: "Web",
      fb: "",
      insta: "https://www.instagram.com/Jiaaa_6_2/",
      linkedin:
        "https://www.linkedin.com/in/antima-dhakad-107621415?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      mail: "mailto:antimad25@iitk.ac.in",
      image: "/team/team26/Antima Dhakad.jpg",
    },
    {
      id: "4",
      name: "Soniya Mina",
      post: "Design",
      fb: "",
      insta: "https://www.instagram.com/its_soniyyaaa/",
      linkedin:
        "https://www.linkedin.com/in/soniya-mina-063156374?utm_source=share_via&utm_content=profile&utm_medium=member_androi",
      mail: "mailto:soniyamina25@iitk.ac.in",
      image: "/team/team26/Soniya Meena.jpeg",
    },
    {
      id: "5",
      name: "Vineeta Meena",
      post: "Events",
      fb: "",
      insta: "https://www.instagram.com/v.neeta_rwt/",
      linkedin:
        "https://www.linkedin.com/in/vineeta-meena-2601813a4?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      mail: "mailto:vineetam25@iitk.ac.in",
      image: "/team/team26/Vineeta Meena.png",
    },
    
    {
      id: "7",
      name: "Thanusri Ganta",
      post: "Design",
      fb: "",
      insta: "https://www.instagram.com/its_soniyyaaa/",
      linkedin: "https://www.linkedin.com/in/thanusriganta",
      mail: "mailto:gthanusri25@iitk.ac.in",
      image: "/team/team26/Thanu Sri Ganta.jpg",
    },
    {
      id: "8",
      name: "Theddu Amulya",
      post: "Web",
      fb: "",
      insta: "https://www.instagram.com/amulya_231014/",
      linkedin:
        "https://www.linkedin.com/in/amulya-theddu-2862b3398?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      mail: "mailto:theddu25@iitk.ac.in",
      image: "/team/team26/amulya theddu.jpg",
    },
    {
      id: "9",
      name: "Rohit Beniwal ",
      post: "Media and Content",
      fb: "",
      insta: "https://www.instagram.com/rohitttt.t_/",
      linkedin: "https://www.instagram.com/rohitttt.t_/",
      mail: "mailto:rohitb25@iitk.ac.in",
      image: "/team/team26/Rohit Beniwal.jpg",
    },
    {
      id: "10",
      name: "Mohit Shrivastava ",
      post: "Finance and Marketing",
      fb: "",
      insta: "https://www.instagram.com/chitransh_mohit951/",
      linkedin:
        "https://www.linkedin.com/in/mohit-shrivastava-b0b12b208?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      mail: "mailto:mohitsh25@iitk.ac.in",
      image: "/team/team26/Mohit Shrivastava.jpg",
    },
    {
      id: "11",
      name: "Satyawart",
      post: "Finance and Marketing",
      fb: "",
      insta: "https://www.instagram.com/satyawart07/",
      linkedin:
        "https://www.linkedin.com/in/satyawart-469966179?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      mail: "mailto:mohitsh25@iitk.ac.in",
      image: "/team/team26/SATYAWART.jpg",
    },
    {
      id: "12",
      name: "Nitesh Kumar",
      post: "Media and Content",
      fb: "",
      insta: "https://www.instagram.com/@mr.nitesh___/",
      linkedin:
        "https://www.linkedin.com/in/nitesh-kumar-00ba1037b?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      mail: "mailto:knitesh25@iitk.ac.in",
      image: "/team/team26/Nitesh Kumar.jpg",
    },
    {
      id: "13",
      name: "Shashank Shekhar",
      post: "Events",
      fb: "",
      insta: "https://www.instagram.com/shashank.j_/",
      linkedin: "http://www.linkedin.com/in/shashank-shekhar-8398b4391",
      mail: "mailto:shashanks25@iitk.ac.in",
      image: "/team/team26/Shashank.jpeg",
    },
    {
      id: "14",
      name: "Yugank Anand Singh",
      post: "Finance and Marketing",
      fb: "",
      insta: "https://www.instagram.com/ank.yug.07/",
      linkedin:
        "https://www.linkedin.com/in/yugank-anand-singh-809874376?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      mail: "mailto:yugank25@iitk.ac.in",
      image: "/team/team26/Yugank Anand Singh.webp",
    },
   
    {
      id: "3",
      name: "Vipul Yadav ",
      post: "Events",
      fb: "",
      insta: "https://www.instagram.com/vipuliitk/",
      linkedin: "https://in.linkedin.com/in/vipul-yadav-302aa720b",
      mail: "mailto:vipuly25@iitk.ac.in",
      image: "/team/team26/vipul.jpg",
    },
    {
      id: "17",
      name: "Patil Lalita Chandrakant ",
      post: "Media and Content",
      fb: "",
      insta: "https://www.instagram.com/lalita_patil_24/",
      linkedin:
        "www.linkedin.com/in/ lalita-patil-1857b5245 Vanity URL name",
      mail: "mailto:lalitacp25@iitk.ac.in",
      image: "/team/team26/lalitapatil.jpeg",
    },
    {
      id: "18",
      name: "Tejas Tanmay",
      post: "Events",
      fb: "",
      insta: "https://www.instagram.com/tejas__tanmay/",
      linkedin: "https://in.linkedin.com/in/tejas-tanmay-215836377",
      mail: "mailto:tejas25@iitk.ac.in",
      image: "/team/team26/Tejas Tanmay.jpeg",
    },
    {
      id: "19",
      name: "Upasna",
      post: "Events",
      fb: "",
      insta: "https://www.instagram.com/goyal_019/",
      linkedin: "https://www.linkedin.com/in/upasna-g-a21b67152/",
      mail: "mailto:upasna23@iitk.ac.in",
      image: "/team/team26/Upasna.jpeg",
    },
    {
      id: "20",
      name: "Pankaj Kumar Jatav",
      post: "Finance and Marketing",
      fb: "",
      insta: "",
      linkedin:
        "https://www.linkedin.com/in/pankaj-kumar-jatav-89647b379",
      mail: "mailto:pankajkj25@iitk.ac.in/",
      image: "/team/team26/Pankaj Kumar - PANKAJ KUMAR.jpeg",
    },
  ],
];

module.exports = team26;